import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import { doc, getDoc } from "firebase/firestore"
import { useParams } from "react-router-dom"
import { db } from '../../../firebase'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

const Single = ({user}) => {

  const {groupId} = useParams()


  const [ groupData, setGroupData ] = useState("")


  const getGroup = async() => {

      const docRef = doc(db, "announcements", groupId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setGroupData(docSnap.data())
        // console.log(userData)
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }

  useEffect(()=>{

    getGroup()
    
  }, [])


  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
         <div className='top'>
                  <div className='topLeft'><h1></h1></div>
                  
                  <div className='topRight'>
                  <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/">
                      Home
                    </Link>
                    <Link
                      underline="hover"
                      color="inherit"
                      href="/group"
                    >
                      Notification List
                    </Link>
                    <Typography color="green">Notification Detail</Typography>
                  </Breadcrumbs>
                  </div>
                </div>
        <div className="top">
          <div className="left">
            <div style={{display: 'flex', flexDirection:'row', alignItems:'center', gap:20, marginLeft:20}}>
            <h2 className='title'>Announcement Information</h2>
            

            </div>
            <div className='item'>
       
                <div className="details">
                  <h3 className='itemTitle'>{groupData.timestamp}</h3>

                   {/* <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{groupData.title}</span>
                  </div> */}
                 
                  {/* <div className='detailItem'>
                    <span className='itemKey'>Subscriber Plan:</span>
                    <span className='itemValue'>{groupData.plan}</span>
                  </div> */}
                  
                 

                   <div className='detailItem'>
                    <span className='itemKey'>Title:</span>
                    <span className='itemValue'>{groupData.title}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Message:</span>
                    <span className='iitemValue'>{groupData.body}</span>
                  </div>
                </div>
            </div>
          </div>
        
        </div>
      
      </div>
    </div>
  )
}

export default Single